/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getParamedics } from 'app/entities/paramedic/paramedic.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './paramedic-access.reducer';

export const ParamedicAccessUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const paramedics = useAppSelector(state => state.paramedic.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const paramedicAccessEntity = useAppSelector(state => state.paramedicAccess.entity);
  const loading = useAppSelector(state => state.paramedicAccess.loading);
  const updating = useAppSelector(state => state.paramedicAccess.updating);
  const updateSuccess = useAppSelector(state => state.paramedicAccess.updateSuccess);

  const handleClose = () => {
    navigate(`/paramedic-access${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getParamedics({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...paramedicAccessEntity,
      ...values,
      comboUser: paramedics.find(it => it.id.toString() === values.comboUser?.toString()),
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...paramedicAccessEntity,
          comboUser: paramedicAccessEntity?.comboUser?.id,
          glucoUser: paramedicAccessEntity?.glucoUser?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paramedicAccess.home.createOrEditLabel" data-cy="ParamedicAccessCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paramedicAccess.home.createOrEditLabel">Create or edit a ParamedicAccess</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="paramedic-access-id"
                  label={translate('tinyMedicRestApp.paramedicAccess.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.uhid')}
                id="paramedic-access-uhid"
                name="uhid"
                data-cy="uhid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.active')}
                id="paramedic-access-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.revoked')}
                id="paramedic-access-revoked"
                name="revoked"
                data-cy="revoked"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.timestampentry')}
                id="paramedic-access-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.microSec')}
                id="paramedic-access-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.lastupdated')}
                id="paramedic-access-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicAccess.cursor')}
                id="paramedic-access-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="paramedic-access-comboUser"
                name="comboUser"
                data-cy="comboUser"
                label={translate('tinyMedicRestApp.paramedicAccess.comboUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {paramedics
                  ? paramedics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="paramedic-access-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.paramedicAccess.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/paramedic-access" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParamedicAccessUpdate;
